import { DIContainer } from "./core/di";
import SentryLogger from "./adapters/logger/sentry";
import ConsoleLogger from "./adapters/logger/console";
import ConsoleAnalyticsProvider from "./adapters/analytics/console";
import RecurlyApi from "./adapters/recurly-api/actual-api/recurly";
import MixpanelAnalyticsProvider from "./adapters/analytics/mixpanel";
import NexarApi from "./adapters/nexar-api/actual-api/api";
import MockNexarApi from "./adapters/nexar-api/mock-api/personal-cloud-api";
import CompositeAnalyticsProvider from "./adapters/analytics/composite";
import GtmAnalyticsProvider from "./adapters/analytics/gtm";
export type Envs = "development" | "production" | "staging";
type WiredDependencies = (env: Envs) => DIContainer;

const dependencies: WiredDependencies = (env) => {
  switch (env) {
    case "development":
      return {
        logger: ConsoleLogger,
        analytics: ConsoleAnalyticsProvider(ConsoleLogger),
        nexarApi: MockNexarApi,
        recurlyApi: RecurlyApi,
      };
    case "production":
      return {
        logger: SentryLogger,
        analytics: CompositeAnalyticsProvider([
          MixpanelAnalyticsProvider(SentryLogger),
          GtmAnalyticsProvider(SentryLogger),
        ]),
        nexarApi: NexarApi,
        recurlyApi: RecurlyApi,
      };
    case "staging":
      return {
        logger: ConsoleLogger,
        analytics: ConsoleAnalyticsProvider(ConsoleLogger),
        nexarApi: NexarApi,
        recurlyApi: RecurlyApi,
      };
  }
};
export default dependencies;
